<template>
  <AGTextField
    required
    :hide-details="hideDetails"
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    :disabled="disabled"
    :error-messages="errorMessages"
    :hint="hint"
    :label="label"
    :maxlength="maxlength"
    :model-value="value"
    :placeholder="placeholder"
    :readonly="readonly"
    :rules="rules"
    :type="showPassword ? 'text' : 'password'"
    @click:append-inner="showPassword = !showPassword"
    @update:model-value="onInput"
  />
</template>

<script>
import AGTextField from '@/components/common/AGTextField.vue';

export default {
  components: { AGTextField },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Number, String],
      default: '',
    },

    hint: {
      type: String,
      default: undefined,
    },

    errorMessages: {
      type: String,
      default: undefined,
    },

    label: {
      type: String,
      default: 'Senha',
    },

    required: {
      type: [Boolean, String],

      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
    },

    rules: {
      type: Array,
      default: () => [],
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    maxlength: {
      type: [Number, String],
      default: undefined,
    },

    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
  },

  data: () => ({
    showPassword: false,
  }),

  computed: {
    value: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input {
  ::v-deep(input__slot) {
    .v-input__slot {
      background-color: $neutral-color-low-light;
      padding: 0 $spacing-inset-05 !important;

      .v-field__field input {
        color: $brand-color-primary-medium !important;

        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        &[type='number'] {
          -moz-appearance: textfield;
        }
      }

      fieldset {
        color: $neutral-color-high-light !important;
      }

      &:hover {
        background-color: $brand-color-highlight-light;

        fieldset {
          color: $neutral-color-low-dark !important;
        }
      }
    }

    .v-input__append-inner {
      margin-top: 13px !important;

      i {
        color: $brand-color-primary-medium !important;
      }
    }

    &.text-error {
      fieldset {
        border-color: $feedback-color-error-medium;
      }
    }

    .v-text-field__details {
      margin: 0;

      .v-messages {
        .v-messages__message {
          padding-bottom: 2px;

          color: $neutral-color-high-medium;
          font-style: normal;
          line-height: 133%; /* 15.96px */
          letter-spacing: 0.12px;
        }

        &.text-error .v-messages__message {
          padding-left: 18px !important;
          background: url('https://api.iconify.design/bxs/error-circle.svg?color=rgba(150, 45, 51, 1)') no-repeat top
            left;
        }
      }
    }

    &.v-input--disabled {
      .v-input__control {
        .v-input__slot {
          background-color: $neutral-color-low-dark;

          fieldset {
            color: $neutral-color-low-medium !important;
          }

          .v-field__field input {
            color: $neutral-color-high-medium !important;
          }
        }
      }

      i {
        color: $neutral-color-high-medium !important;
      }
    }

    &.v-input--is-focused {
      .v-input__control {
        fieldset {
          color: $brand-color-primary-medium;
        }

        &:hover {
          fieldset {
            color: $brand-color-primary-medium !important;
          }
        }
      }
    }

    input {
      position: relative;
      top: 8px;
    }

    legend {
      width: 0 !important;
    }

    .v-label {
      color: $brand-color-primary-medium;
      font-size: $font-size-xs;
      font-weight: $font-weight-regular;
      line-height: $line-height-lg;
      letter-spacing: 0.16px;
      top: 12px !important;

      &.v-label--is-disabled {
        color: $neutral-color-high-medium !important;
      }

      &.v-label--active {
        color: $neutral-color-high-medium;
        top: 20px !important;
      }
    }
  }
}
</style>
